import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { IconComponent } from 'src/app/ui/icon/icon.component';
import { MapToolbarService } from '../services/map-toolbar.service';
import { MapToolbarAction, MapToolbarPayload } from './map-toolbar-actions';
import { FilterLayer, MapLayerTypeEnum } from 'src/app/model/map.model';
import { ToggleButtonComponent } from 'src/app/ui/toggle-button/toggle-button.component';
import { Router } from '@angular/router';

@Component({
  selector: 'rqa-map-toolbar',
  templateUrl: './map-toolbar.component.html',
  styleUrls: ['./map-toolbar.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, IconComponent, TooltipModule, ButtonModule, ToggleButtonComponent]
})
export class MapToolbarComponent {
  @Input()
  set filterLayerTypes(value: FilterLayer[]) {
    // Filter layers based on current route
    const filteredLayers = this.getFilteredLayersForCurrentRoute(value);

    this.groupLayers1 = filteredLayers.filter((el) => Object.keys(MapLayerTypeEnum).includes(el.type));
    this.groupLayers2 = filteredLayers.filter(
      (el) => ![...Object.keys(MapLayerTypeEnum), 'CTR', 'MCTR', 'TMA', 'MTMA', 'SECTOR'].includes(el.type)
    );
    this.groupLayers3 = filteredLayers.filter((el) => ['CTR', 'MCTR', 'TMA', 'MTMA'].includes(el.type));
    this.groupLayers4 = filteredLayers.filter((el) => el.type === 'SECTOR');
  }
  isLayerSubmenuVisible = false;
  groupLayers1: FilterLayer[] = [];
  groupLayers2: FilterLayer[] = [];
  groupLayers3: FilterLayer[] = [];
  groupLayers4: FilterLayer[] = [];
  private mapToolbarService = inject(MapToolbarService);
  private router = inject(Router);

  private getFilteredLayersForCurrentRoute(layers: FilterLayer[]): FilterLayer[] {
    const currentUrl = this.router.url;

    return layers.filter((layer) => {
      if (Object.values(MapLayerTypeEnum).includes(layer.type as MapLayerTypeEnum)) {
        if (layer.type === MapLayerTypeEnum.AUP || layer.type === MapLayerTypeEnum.UUP) {
          return currentUrl.startsWith('/observer') || currentUrl === '/observer';
        }
        if (layer.type === MapLayerTypeEnum.RQA) {
          return currentUrl === '/' || currentUrl === '';
        }

        if (layer.type === MapLayerTypeEnum.ORDER) {
          return currentUrl.startsWith('/orders') || currentUrl === '/orders';
        }

        if (layer.type === MapLayerTypeEnum.TEMPLATE) {
          return currentUrl.startsWith('/templates') || currentUrl === '/templates';
        }
        return true;
      }

      return true;
    });
  }

  onSearch(): void {
    this.emitAction('search');
  }

  onZoomOut(): void {
    this.emitAction('zoomOut');
  }

  onZoomIn(): void {
    this.emitAction('zoomIn');
  }

  onToggleLayerGroup(visible: boolean, groupId: string): void {
    this.emitAction('toggleLayerGroup', { visible, groupId });
  }

  onFilters(): void {
    this.emitAction('filters');
  }

  private emitAction(action: MapToolbarAction, payload?: MapToolbarPayload): void {
    this.mapToolbarService.emitAction(action, payload);
  }
}
